module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('sub-tabs', {
    attrs: {
      "nomeSessao": "Relatórios",
      "tabs": _vm.tabs
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bae4ebc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/relatorios/index.vue
// module id = 772
// module chunks = 24